import React from 'react'
import styled from 'styled-components'
import PeopleCard from './PeopleCard'

const PeopleList = ({
  users = [],
  showFollowersCount = false,
  followLabel,
  followingLabel,
  followersCountLabel,
  pendingFollowIds,
  onOpenProfile,
  onToggleFollow
}) => {
  return (
    <List>
      {users.map(person => (
        <PeopleCard
          key={person.id}
          person={person}
          showFollowersCount={showFollowersCount}
          followLabel={followLabel}
          followingLabel={followingLabel}
          followersCountLabel={followersCountLabel}
          isPending={pendingFollowIds.has(String(person.id))}
          onOpenProfile={onOpenProfile}
          onToggleFollow={onToggleFollow}
        />
      ))}
    </List>
  )
}

export default PeopleList

const List = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.border.defaultSubtle};
  border-radius: ${({ theme }) => theme.radius.xs};
  overflow: hidden;
`
